export default "<div class=\"client-account__default-text\">{{ text }}</div>\n";